<script setup>
// BonBoZ: các tin SAU tin đầu của một mẫu trả lời (issue #120).
//
// Tin đầu vẫn là ô soạn thảo `content` sẵn có; mỗi tin sau là một ô ở đây, gửi
// thành một bong bóng riêng theo đúng thứ tự (xem `mauNhieuTin.js`).
//
// Ô chữ thường chứ không phải trình soạn thảo đầy đủ: tin sau của mẫu Pancake
// là chữ trơn, và mỗi trình soạn thảo là một ProseMirror nặng — mẫu 3 tin trong
// form thêm hàng loạt 20 dòng là 60 cái.
//
// Đổi thứ tự bằng nút lên/xuống thay vì kéo thả: mỗi mẫu tối đa vài tin, và kéo
// thả trong hộp thoại cuộn được rất dễ thả nhầm.
const tin = defineModel({ type: Array, default: () => [] });

const them = () => {
  tin.value = [...tin.value, ''];
};

const sua = (i, noiDung) => {
  const moi = [...tin.value];
  moi[i] = noiDung;
  tin.value = moi;
};

const bo = i => {
  tin.value = tin.value.filter((_, j) => j !== i);
};

const doi = (i, buoc) => {
  const j = i + buoc;
  if (j < 0 || j >= tin.value.length) return;
  const moi = [...tin.value];
  [moi[i], moi[j]] = [moi[j], moi[i]];
  tin.value = moi;
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="(t, i) in tin" :key="i" class="flex items-start gap-2">
      <span class="w-12 pt-2 text-xs shrink-0 text-n-slate-11">
        {{ $t('BONBOZ.TIN_THEM.NHAN', { so: i + 2 }) }}
      </span>
      <textarea
        :value="t"
        rows="2"
        class="!mb-0 flex-1 text-sm resize-y"
        :placeholder="$t('BONBOZ.TIN_THEM.GOI_Y')"
        @input="sua(i, $event.target.value)"
      />
      <div class="flex flex-col shrink-0">
        <button
          type="button"
          class="grid rounded size-6 place-items-center text-n-slate-11 hover:bg-n-alpha-2 disabled:opacity-30"
          :disabled="i === 0"
          :aria-label="$t('BONBOZ.TIN_THEM.LEN')"
          @click="doi(i, -1)"
        >
          <span class="i-lucide-chevron-up size-3.5" />
        </button>
        <button
          type="button"
          class="grid rounded size-6 place-items-center text-n-slate-11 hover:bg-n-alpha-2 disabled:opacity-30"
          :disabled="i === tin.length - 1"
          :aria-label="$t('BONBOZ.TIN_THEM.XUONG')"
          @click="doi(i, 1)"
        >
          <span class="i-lucide-chevron-down size-3.5" />
        </button>
      </div>
      <button
        type="button"
        class="grid mt-1 rounded size-6 place-items-center text-n-ruby-11 hover:bg-n-ruby-3 shrink-0"
        :aria-label="$t('BONBOZ.TIN_THEM.BO')"
        @click="bo(i)"
      >
        <span class="i-lucide-x size-3.5" />
      </button>
    </div>
    <div>
      <button
        type="button"
        class="inline-flex items-center gap-1 px-2.5 py-1 text-xs rounded-md bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3"
        @click="them"
      >
        <span class="i-lucide-plus size-3.5" />
        {{ $t('BONBOZ.TIN_THEM.THEM') }}
      </button>
    </div>
  </div>
</template>
